import { ITeamLastNextMatch } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const TeamLastNextMatchWrapper = React.lazy(() => import('./team-last-next-match'));
export interface IDynamicTeamLastNextMatch extends IComponentModel<ITeamLastNextMatch> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicTeamLastNextMatch = ({
  /* istanbul ignore next: default value */ model = {} as ITeamLastNextMatch,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicTeamLastNextMatch) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <TeamLastNextMatchWrapper
      live={live}
      initialModel={validateModel(model) as ITeamLastNextMatch}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicTeamLastNextMatch;
